
import type { PropType } from 'vue'
import type { EpbBaseInputSize } from './epb-base-input.types'
import { defineComponent } from 'vue'
import { EpbInputHelp } from '../epb-input-help'
import { EpbInputLabel } from '../epb-input-label'

export default defineComponent({
  name: 'EpbBaseInput',
  components: {
    EpbInputHelp,
    EpbInputLabel,
  },
  props: {
    help: {
      type: String,
      default: undefined,
    },
    helpIcon: {
      type: String,
      default: undefined,
    },
    label: {
      type: String,
      default: undefined,
    },
    icon: {
      type: String,
      default: undefined,
    },
    size: {
      type: String as PropType<EpbBaseInputSize>,
      default: 'md',
    },
    error: {
      type: String,
      default: undefined,
    },
    disabled: Boolean,
    required: Boolean,
  },
  setup() {
    const baseClass = 'epb-base-input'

    return {
      baseClass,
    }
  },
})
